import { cloneDeep } from 'lodash';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsRequest } from '../../generic/communications-request/communications-request';
import { CommunicationsRequestSchema } from '../../generic/communications-request/communications-request-schema';

import { CommunicationsRequestConferenceParticipantUpdateConstructor } from './communications-request-conference-participant-update-constructor';
import { CommunicationsRequestConferenceParticipantUpdateSchema } from './communications-request-conference-participant-update-schema';

export class CommunicationsRequestConferenceParticipantUpdate extends CommunicationsRequest {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected conferenceFriendlyName!: string;

  protected callSid!: string;

  protected hold?: boolean;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsRequestConferenceParticipantUpdateConstructor) {
    super({ ...parameters, [CommunicationsRequestSchema.type]: CommunicationsRequestName.conferenceParticipantUpdate });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsRequestConferenceParticipantUpdate {
    return new CommunicationsRequestConferenceParticipantUpdate(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsRequestConferenceParticipantUpdate.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsRequestConferenceParticipantUpdateSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Roles
  /////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line class-methods-use-this
  public getRequiredRoles(): PossibleRole[] {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  public getRequiredAdminRoles() {
    return [];
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getConferenceFriendlyName() {
    return cloneDeep(this.conferenceFriendlyName);
  }

  public getCallSid() {
    return cloneDeep(this.callSid);
  }

  public getHold() {
    return cloneDeep(this.hold);
  }
}
